// extracted by mini-css-extract-plugin
export default {"header":"PopOver_header__wVAtK","close":"PopOver_close__d3g3g"};